module.exports = __webpack_public_path__ + "static/img/DNB-Selected.6ec9912.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/DNB-Selected.png
// module id = 1752
// module chunks = 0